module.exports = __webpack_public_path__ + "static/media/Radiant_jacket.73dfb9dd.jpg";